class PremiumSplideComponent extends HTMLElement {
  constructor() {
    super();
    this.innerSplide = this.querySelector('.splide');
    if (!this.innerSplide) return;

    // Configuration from data attributes
    this.type = this.dataset.type || 'slide';
    this.autoplay = this.dataset.autoplay === 'true';
    this.autoplaySpeed = Number(this.dataset.autoplaySpeed || 5) * 1000;
    this.drag = this.dataset.drag !== 'false' ? (this.dataset.drag === 'free' ? 'free' : true) : false;
    this.focus = this.dataset.focus || undefined;
    
    this.perPageDesktop = Number(this.dataset.slidesDesktop || 3);
    this.perMoveDesktop = Number(this.dataset.perMoveDesktop || 1);
    this.gapDesktop = Number(this.dataset.gapDesktop || 28);
    this.paddingDesktop = Number(this.dataset.sidePaddingDesktop || 0);

    this.perPageMobile = Number(this.dataset.slidesMobile || 2);
    this.perMoveMobile = Number(this.dataset.perMoveMobile || 1);
    this.gapMobile = Number(this.dataset.gapMobile || 12);
    this.paddingMobile = Number(this.dataset.sidePaddingMobile || 0);
    
    this.arrowsColor = this.dataset.arrowsColor || 'scheme-1';
    this.dotsColor = this.dataset.dotsColor || 'scheme-1';

    this.init();
  }

  async init() {
    await this.loadSplide();
    this.mountSplide();
  }

  loadSplide() {
    return new Promise((resolve) => {
      let isLoaded = !!window.Splide;
      let jsScript = document.querySelector('script[src*="splide.min.js"]');
      let cssLink = document.querySelector('link[href*="splide.min.css"]');
      
      if (!jsScript) {
        jsScript = document.createElement('script');
        jsScript.src = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';
        document.head.appendChild(jsScript);
      }
      
      if (!cssLink) {
        cssLink = document.createElement('link');
        cssLink.rel = 'stylesheet';
        cssLink.href = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/css/splide.min.css';
        document.head.appendChild(cssLink);
      }

      if (isLoaded) {
        resolve();
      } else {
        jsScript.addEventListener('load', resolve);
      }
    });
  }

  mountSplide() {
    const config = {
      type: this.type,
      autoplay: this.autoplay,
      interval: this.autoplaySpeed,
      drag: this.drag,
      focus: this.focus,
      perPage: this.perPageDesktop,
      perMove: this.perMoveDesktop,
      gap: this.gapDesktop,
      padding: this.paddingDesktop,
      pagination: true,
      arrows: true,
      classes: {
        arrows: `splide__arrows color-${this.arrowsColor}`,
        pagination: `splide__pagination color-${this.dotsColor}`
      },
      breakpoints: {
        749: {
          perPage: this.perPageMobile,
          perMove: this.perMoveMobile,
          gap: this.gapMobile,
          padding: this.paddingMobile,
        }
      }
    };

    this.splideInstance = new Splide(this.innerSplide, config);
    this.splideInstance.mount();
    this.classList.add('is-initialized');
  }
}

if (!customElements.get('premium-splide-component')) {
  customElements.define('premium-splide-component', PremiumSplideComponent);
}

class PremiumCopyButton extends HTMLElement {
  constructor() {
    super();
    this.button = this;
    if (this.tagName === 'PREMIUM-COPY-BUTTON') {
      this.button = this;
    }
    this.addEventListener('click', this.copyToClipboard.bind(this));
  }

  copyToClipboard() {
    const textToCopy = this.getAttribute('data-content') || this.innerText;
    navigator.clipboard.writeText(textToCopy).then(() => {
      this.setAttribute('data-success', 'true');
      setTimeout(() => {
        this.setAttribute('data-success', 'false');
      }, 2000);
    });
  }
}

if (!customElements.get('premium-copy-button')) {
  customElements.define('premium-copy-button', PremiumCopyButton);
}
